/**
 * Compute fixed-position tooltip geometry in viewport coordinates.
 *
 * Uses getBoundingClientRect-style values (no document scroll offsets) so the
 * tip stays correct when portaled into a positioned ancestor such as
 * `#root-modals`.
 *
 * @param {Object} params
 * @param {{top: number, left: number, bottom: number, width: number}} params.anchorRect
 * @param {number} params.tipW
 * @param {number} params.tipH
 * @param {number} params.vpW
 * @param {number} params.vpH
 * @param {number=} params.gap
 * @return {{top: number, left: number, placement: "top"|"bottom", arrowLeft: string}}
 */
export function computeTooltipCoords({
  anchorRect,
  tipW,
  tipH,
  vpW,
  vpH,
  gap = 8,
}) {
  const anchorCX = anchorRect.left + anchorRect.width / 2;

  let left = anchorCX - tipW / 2;
  const minLeft = 12;
  const maxLeft = vpW - tipW - 12;
  left = Math.max(minLeft, Math.min(left, maxLeft));

  let arrowPx = anchorCX - left;
  if (arrowPx < 12) arrowPx = 12;
  if (arrowPx > tipW - 12) arrowPx = tipW - 12;

  let top = anchorRect.bottom + gap;
  let placement = "bottom";
  if (top + tipH > vpH) {
    top = anchorRect.top - tipH - gap;
    placement = "top";
  }

  return {
    top,
    left,
    placement,
    arrowLeft: `${arrowPx}px`,
  };
}
